import Iconify from '@/components/iconify/index.tsx';
import { Button } from '@mui/material';
import { useAppSearchParams } from '@/hooks/useAppSearchParams.ts';
import { useRunTournamentLeaderboardScoringMutation } from '@/api/league-tournament-leaderboard/runTournamentLeaderboardScoring.ts';

export const UpdateAllLeaderboardsButton = () => {
  const { pickemId } = useAppSearchParams();

  const { mutateAsync, isPending } =
    useRunTournamentLeaderboardScoringMutation();

  const handleForceTournamentsScoring = () => {
    mutateAsync(pickemId).then(() => window.location.reload());
  };

  return (
    <Button
      variant='contained'
      startIcon={<Iconify icon='eva:list-outline' />}
      onClick={() => handleForceTournamentsScoring()}
      sx={{ mr: 2 }}
      disabled={isPending}
    >
      Update All Leaderboards
    </Button>
  );
};
